import { useMutation } from "react-query";
import http from "infra/http";

function useCancelarReserva() {
  return useMutation(
    ({id, motivo}: {id: string, motivo?: string}) => {
      return http.post(`/v1/reserva/${id}/cancelar`, {
        motivo
      });
    },
    { retry: false }
  );
}

export default useCancelarReserva;
